import React, { Component } from 'react'

import InstrumentLightweightCharts from '@/components/@charting/InstrumentLightweightCharts'

import '../../../assets/styles/components/detail-center/chart.scss'

export default class Chart extends Component {
    render() {
        return (
            <div className='chart' style={{width:'100%'}} >
                <InstrumentLightweightCharts chart_id={'market-detail-char'} ></InstrumentLightweightCharts>
            </div>
        )
    }

    componentWillUnmount() {
        this.setState = () => {
          return
        }
      }
}
